import { brand } from "@/brandVariables/getBandVariables";
import { ClientProps } from "@/hooks/useClientData";
import { FC } from "react";

import { WinnerCard } from "./components/WinnerCard";
import { BrandLogo } from "../reusable/brandLogo";

// Days to display winners for
const WINNING_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

// End screen for when there are no more events or to show current winners
export const RACINGEndScreen: FC<{ clientData: ClientProps }> = ({
  clientData,
}) => {
  const winners = clientData.winners.data;
  const hasActiveChallenge =
    clientData.hasActiveChallenge && clientData.leaderboard.data;

  const isElgigantenTextClass =
    brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";
  const isElgigantenAltClass =
    brand.client === "elgiganten-9u2oj" ? "isElgiganten" : "";

  const renderHeader = () => {
    if (!hasActiveChallenge) {
      return (
        <h1>
          {winners?.length !== 0 ? (
            <>
              {brand.content.endscreenHeadline}{" "}
              <span className={isElgigantenTextClass}>
                top racers<span>!</span>
              </span>
            </>
          ) : (
            "Thank you to all the participants"
          )}
        </h1>
      );
    }

    return (
      <h1>
        {winners ? (
          <>
            {brand.content.overviewHeadline}{" "}
            <span className={isElgigantenTextClass}>overview!</span>
          </>
        ) : (
          "Winners overview"
        )}
      </h1>
    );
  };

  return (
    <div className="endScreen">
      <div className="endScreen__heading">
        {renderHeader()}
        <div className="brand-logo">
          <BrandLogo />
        </div>
      </div>

      {winners && (
        <div className="winners">
          {WINNING_DAYS.map((day) => {
            const winnersOfDay = winners.filter(
              (winner) => winner.winningDay === day
            );
            if (!winnersOfDay.length) return null;

            return (
              <section key={day}>
                <div className={`winners__header ${isElgigantenAltClass}`}>
                  <h2>{day}</h2>
                </div>
                <div className="winners__day">
                  {winnersOfDay.map((winner, index) => {
                    const key = index;
                    return (
                      <WinnerCard
                        key={`winner-${key}`}
                        winnerToUser={winner}
                        clientData={clientData}
                        hasBanner={false}
                      />
                    );
                  })}
                </div>
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
};
